import React from 'react'
import { useNavigate } from 'react-router-dom'
import NiceModal from '@ebay/nice-modal-react'

import SearchWrapper from 'app/mainframe/components/Search/SearchWrapper'
import ProfileResult from 'app/mainframe/components/Search/results/ProfileResult'
import ContentResult from 'app/mainframe/components/Search/results/ContentResult'
import PrimerResult from 'app/mainframe/components/Search/results/PrimerResult'

const getIndex = key => {
  const indices = {
    user: {
      key: 'user',
      title: 'People',
      component: <ProfileResult />
    },
    content: {
      key: 'content',
      title: 'Content',
      component: <ContentResult />
    },
    primer: {
      key: 'primer',
      title: 'Collection',
      component: <PrimerResult />
    }
  }
  return indices[key]
}

const UniversalSearch = () => {
  const navigate = useNavigate()

  return (
    <SearchWrapper
      autoFocus
      placeholder='Search content, people, or collections'
      indices={[getIndex('content'), getIndex('user'), getIndex('primer')]}
      onSelect={item => {
        NiceModal.hide('search-modal')
        item.form_slug
          ? navigate(`/${item.form_slug}/${item.slug}`)
          : item.username
          ? navigate(`/@${item.username}`)
          : navigate(`/collection/${item.slug}`)
      }}
    />
  )
}

const AddContentSearch = ({ onSelect }) => {
  return (
    <SearchWrapper
      autoFocus
      placeholder='Search or paste a link'
      indices={[getIndex('content')]}
      onSelect={item => {
        onSelect(item)
      }}
    />
  )
}

export { UniversalSearch, AddContentSearch }
